import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { Covers } from "../enum/Covers";
import { LTProducts } from "../enum/LTProducts";
import type { FlightCaseSettings } from "../interfaces/FlightCaseSettings";
import { createCoverOptions } from "../structure/RackInterior";
import { FlightCaseDefinition } from "./FlightCaseDefinition";

export class Truhe extends FlightCaseDefinition {
  public static getSerializedDefaultVersion(
    optionDb: OptionDB,
  ): FlightCaseSettings {
    const result: FlightCaseSettings =
      FlightCaseDefinition.getSerializedDefaultVersion(optionDb);
    result.type = LTProducts.Truhe;
    result.exteriorOptions.strength = 6.5;
    result.variableOptions = [];
    result.cuts = [
      {
        offset: 50,
        reference: Sides.TOP,
        groupName: Covers.COVER,
      },
    ];
    result.coverPaddings = createCoverOptions(optionDb, result.cuts);
    return result;
  }
}
